// extracted by mini-css-extract-plugin
export var accentPrimary = "Icon-module--accentPrimary--15185";
export var accentSecondary = "Icon-module--accentSecondary--e09ee";
export var accentTertiary = "Icon-module--accentTertiary--458a5";
export var caution = "Icon-module--caution--a8865";
export var key = "Icon-module--key--01af4";
export var link = "Icon-module--link--6e996";
export var notice = "Icon-module--notice--a9051";
export var primary = "Icon-module--primary--0fc07";
export var secondary = "Icon-module--secondary--794d8";
export var size3xl = "Icon-module--size3xl--aa1f7";
export var size4xl = "Icon-module--size4xl--76667";
export var sizeL = "Icon-module--sizeL--76aae";
export var sizeM = "Icon-module--sizeM--717bf";
export var sizeS = "Icon-module--sizeS--93ef5";
export var sizeXl = "Icon-module--sizeXl--00bdd";
export var sizeXm = "Icon-module--sizeXm--ba41b";
export var sizeXs = "Icon-module--sizeXs--ad4ef";
export var sizeXxl = "Icon-module--sizeXxl--63209";
export var sizeXxm = "Icon-module--sizeXxm--4f544";
export var tertiary = "Icon-module--tertiary--9cdea";